/* tslint:disable */
/* eslint-disable */
/**
 * Xerjoff.Agenti.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DipendenzaUpdateDTO
 */
export interface DipendenzaUpdateDTO {
    /**
     * 
     * @type {string}
     * @memberof DipendenzaUpdateDTO
     */
    nome?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DipendenzaUpdateDTO
     */
    indirizzo?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DipendenzaUpdateDTO
     */
    cap?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DipendenzaUpdateDTO
     */
    citta?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DipendenzaUpdateDTO
     */
    provinciaCodice?: string | null;
}

/**
 * Check if a given object implements the DipendenzaUpdateDTO interface.
 */
export function instanceOfDipendenzaUpdateDTO(value: object): value is DipendenzaUpdateDTO {
    return true;
}

export function DipendenzaUpdateDTOFromJSON(json: any): DipendenzaUpdateDTO {
    return DipendenzaUpdateDTOFromJSONTyped(json, false);
}

export function DipendenzaUpdateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): DipendenzaUpdateDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'nome': json['nome'] == null ? undefined : json['nome'],
        'indirizzo': json['indirizzo'] == null ? undefined : json['indirizzo'],
        'cap': json['cap'] == null ? undefined : json['cap'],
        'citta': json['citta'] == null ? undefined : json['citta'],
        'provinciaCodice': json['provinciaCodice'] == null ? undefined : json['provinciaCodice'],
    };
}

  export function DipendenzaUpdateDTOToJSON(json: any): DipendenzaUpdateDTO {
      return DipendenzaUpdateDTOToJSONTyped(json, false);
  }

  export function DipendenzaUpdateDTOToJSONTyped(value?: DipendenzaUpdateDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'nome': value['nome'],
        'indirizzo': value['indirizzo'],
        'cap': value['cap'],
        'citta': value['citta'],
        'provinciaCodice': value['provinciaCodice'],
    };
}

